export const parseParams = (queryString: string): any => {
	if (!queryString) return;
	const params = new URLSearchParams(queryString);
	const obj = {};

	for (const key of params.keys()) {
		const val = params.getAll(key);
		if (val.length > 1) {
			obj[key] = val;
		} else {
			obj[key] = params.get(key);
		}
	}
	return obj;
};
